import { z } from 'zod/v4';
import { IEfaToFareResponse, IEfaToFareVia } from './efa-to-fare.interfaces';

export const EFA_TO_FARE_VIA_SCHEMA: z.ZodType<IEfaToFareVia> = z.object({
  tariffId: z.string(),
  startStationId: z.string(),
  startTariffPointId: z.string(),
  endStationId: z.string(),
  endTariffPointId: z.string(),
  viaDescription: z.string().nullable().default(null),
  relationExtRef: z.string(),
  priceStageExtRef: z.string(),
  order: z.number().int().nonnegative(),
});

export const EFA_TO_FARE_RESPONSE_SCHEMA: z.ZodType<IEfaToFareResponse> =
  z.object({
    vias: z.array(EFA_TO_FARE_VIA_SCHEMA),
  });
